import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { FlujoVentaPasoReintentoFuncionalidadControlCausalSolicitud } from '../_models/flujo-venta-paso-reintento-funcionalidad-control-causal-solicitud';

@Injectable({
  providedIn: 'root'
})
export class FlujoVentaPasoReintentoFuncionalidadControlCausalSolicitudService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/flujoVPReintentosFCCausalesSolicitudes';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as FlujoVentaPasoReintentoFuncionalidadControlCausalSolicitud[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as FlujoVentaPasoReintentoFuncionalidadControlCausalSolicitud[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as FlujoVentaPasoReintentoFuncionalidadControlCausalSolicitud ) );
  }

  listadoPorFlujoVenta( idFlujoVenta: string ) {
    return this.httClient.get( this.rutServicio + '/flujoVentaPaso/' + idFlujoVenta ).pipe( map( res => res as FlujoVentaPasoReintentoFuncionalidadControlCausalSolicitud[] ) );
  }

  crear( regCrear: FlujoVentaPasoReintentoFuncionalidadControlCausalSolicitud ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as FlujoVentaPasoReintentoFuncionalidadControlCausalSolicitud ) );
  }

  actualizar( regActualizar: FlujoVentaPasoReintentoFuncionalidadControlCausalSolicitud ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as FlujoVentaPasoReintentoFuncionalidadControlCausalSolicitud ) );
  }

  bulk( regActualizar: FlujoVentaPasoReintentoFuncionalidadControlCausalSolicitud[] ) {
    regActualizar.forEach( e => {
      e.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regActualizar ).pipe( map( res => res as FlujoVentaPasoReintentoFuncionalidadControlCausalSolicitud[] ) );
  }
}
